import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Note } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

type IVideoLesson = Note;

const initialState: IReduxState<IVideoLesson> = {
  data: {} as IVideoLesson,
  isLoading: false,
};

export const AddNoteVideoLessonsSlice = createSlice({
  name: "AddNoteVideoLessonsSlice",
  initialState,
  reducers: {
    // ✅ Do not store the payload (to avoid serializing File objects)
    AddNoteVideoLesson: (state, _action: PayloadAction<IVideoLesson>) => {
      state.isLoading = true;
    },

    successAddNoteVideoLessons: (
      state,
      action: PayloadAction<IVideoLesson>
    ) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAddNoteVideoLessons: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddNoteVideoLessonsResponse: (state) => {
      state.data = {} as IVideoLesson;
    },
  },
});

export const {
  AddNoteVideoLesson,
  successAddNoteVideoLessons,
  failureAddNoteVideoLessons,
  clearAddNoteVideoLessonsResponse,
} = AddNoteVideoLessonsSlice.actions;

export default AddNoteVideoLessonsSlice.reducer;
